import { render, staticRenderFns } from "./IconIntro.vue?vue&type=template&id=61b21765&"
import script from "./IconIntro.vue?vue&type=script&lang=js&"
export * from "./IconIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports